import SignaturePad from '@/components/admin/SignaturePad';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const inputCls = "text-foreground";

export default function StepAppSignature({ form, set, errors }) {
  return (
    <div className="space-y-5">
      <div>
        <h3 className="font-space font-semibold text-foreground text-base">Application Signature</h3>
        <p className="text-xs text-muted-foreground mt-0.5">To be read and signed by the applicant</p>
      </div>

      <div className="rounded-xl border border-border bg-muted/40 p-4 space-y-3 text-xs text-foreground leading-relaxed">
        <p>I authorize you to make investigations (including contacting current and prior employers) into my personal, employment, financial, medical history, and other related matters as may be necessary in arriving at an employment decision. I hereby release employers, schools, health care providers, and other persons from all liability in responding to inquiries and releasing information in connection with my application.</p>
        <p>In the event of employment, I understand that false or misleading information given in my application or interview(s) may result in discharge. I also understand that I am required to abide by all rules and regulations of the Company.</p>
        <p>I understand that the information I provide regarding my current and/or prior employers may be used, and those employer(s) will be contacted for the purpose of investigating my safety performance history as required by 49 CFR 391.23. I understand that I have the right to:</p>
        <ul className="list-disc pl-4 space-y-1">
          <li>Review information provided by current/previous employers;</li>
          <li>Have errors in the information corrected by previous employers, and for those previous employers to resend the corrected information to the prospective employer; and</li>
          <li>Have a rebuttal statement attached to the alleged erroneous information, if the previous employer(s) and I cannot agree on the accuracy of the information.</li>
        </ul>
        <p className="font-semibold">This certifies that I completed this application, and that all entries on it and information in it are true and complete to the best of my knowledge.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <p className="text-xs text-muted-foreground mb-1">Applicant Signature <span className="text-red-400">*</span></p>
          <SignaturePad value={form.app_signature} onChange={v => set('app_signature', v)} />
          {errors.app_signature && <p className="text-xs text-red-400 mt-1">{errors.app_signature}</p>}
        </div>
        <div>
          <label className="text-xs text-muted-foreground block mb-1">Date Signed</label>
          <Input type="date" value={form.app_sign_date} onChange={e => set('app_sign_date', e.target.value)} className={inputCls} />
        </div>
      </div>
    </div>
  );
}